export default __webpack_public_path__ + "static/media/Contact.e04817df.jpg";